  <div
    class="flex justify-center items-center"
    [ngClass]="{
      'total': type() === ePowerType.TOTAL,
      'average': type() === ePowerType.AVERAGE,
      'min': type() === ePowerType.MIN,
      'max': type() === ePowerType.MAX,
      'w-4 h-4 rounded text-xs': size() === 'small',
      'w-9 h-9 rounded-md text-base': size() === 'medium',
    }"
  >
    <i class="icon-ic_power"></i>
  </div>
